import { axiosInstance } from '../helper/axios';
import AnnounceData from "../models/Announce";

const AnnounceAPI = {
    getAnnounce: () => {
        return axiosInstance.get<AnnounceData[]>("api/Announce");
    }
}
export default AnnounceAPI;